// src/components/programs/ProgramForm/Step0Sections/BasicInfoSection.jsx

import React from "react";
import { Grid } from "@mui/material";
import FormInput from "../../../inputs/FormInput";
import CustomerNameInput from "../../../inputs/CustomerNameInput";

const BasicInfoSection = ({
    formData,
    errors,
    isArabic,
    activeLang,
    handleMultiLangChange,
}) => {
    return (
        <Grid container spacing={3} alignItems={'flex-end'}>
            {/* Title */}
            <Grid item xs={12} md={6}>
                <FormInput
                    label={isArabic ? 'اسم البرنامج' : 'Program Name'}
                    placeholder={isArabic ? 'أدخل اسم البرنامج' : 'Enter Program Name'}
                    value={formData.title?.[activeLang] || ''}
                    onChange={(e) => handleMultiLangChange('title', activeLang, e.target.value)}
                    error={!!errors[`title_${activeLang}`]}
                    helperText={errors[`title_${activeLang}`]}
                    required
                    multiline={false}
                />
            </Grid>

            {/* Description (Customer Name) */}
            <Grid item xs={12} md={6}>
                {/* <FormInput
                    label={isArabic ? 'اسم العميل' : 'Customer Name'}
                    placeholder={isArabic ? 'أدخل اسم العميل' : 'Enter customer name'}
                    value={formData.description?.[activeLang] || ''}
                    onChange={(e) => handleMultiLangChange('description', activeLang, e.target.value)}
                    multiline
                    rows={2}
                /> */}
                <CustomerNameInput
                    label={isArabic ? 'اسم العميل' : 'Customer Name'}
                    value={formData.description?.[activeLang] || ''}
                    onChange={(e) => handleMultiLangChange('description', activeLang, e.target.value)}
                    language={activeLang}
                    required
                    error={!!errors?.[`description_${activeLang}`]}
                    helperText={errors?.[`description_${activeLang}`] || ''}
                    fullWidth
                />
            </Grid>
            {/* Agent Name */}
            <Grid item xs={12}>
                <FormInput
                    label={isArabic ? 'اسم الوكيل' : 'Agent Name'}
                    placeholder={isArabic ? 'أدخل اسم الوكيل' : 'Enter Agent Name'}
                    value={formData.agent_name?.[activeLang] || ''}
                    onChange={(e) => handleMultiLangChange('agent_name', activeLang, e.target.value)}
                    error={!!errors[`agent_name_${activeLang}`]}
                    helperText={errors[`agent_name_${activeLang}`]}
                    required
                    multiline={false}
                />
            </Grid>

            {/* ✅ Cities Field */}
            <Grid item xs={12}>
                <FormInput
                    label={isArabic ? 'المدن' : 'Cities'}
                    placeholder={isArabic ? 'مثال: القاهرة، الأقصر، أسوان' : 'Example: Cairo, Luxor, Aswan'}
                    value={formData.cities?.[activeLang] || ''}
                    onChange={(e) => handleMultiLangChange('cities', activeLang, e.target.value)}
                    error={!!errors[`cities_${activeLang}`]}
                    helperText={errors[`cities_${activeLang}`]}
                    multiline={false}
                    required
                />
            </Grid>
        </Grid>
    );
};

export default BasicInfoSection;
